export default class BmcCard {
  constructor({
    '#type': type,
    tid,
    id,
    algorithm,
    data_type: dataType,
    alias,
    wysiwyg,
  }) {
    this.type = type;
    this.tid = tid;
    this.id = id;
    this.algorithm = algorithm;
    this.dataType = dataType;
    this.alias = alias;
    this.wysiwyg = wysiwyg;
  }

  getId() {
    return this.id;
  }

  getWysiwyg() {
    return this.wysiwyg;
  }
}
